var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper-loading"},[_c('img',{staticClass:"mb-5",attrs:{"src":"media/logos/logo-kemendagri.png","alt":""}}),(_vm.status === '')?_c('b-spinner',{attrs:{"large":"","variant":"primary"}}):_vm._e(),(_vm.status === 'error')?_c('span',[_vm._v("Gagal login...")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }